const styles = (theme) => ({
  contentStyles: {
    padding: 16,
    paddingTop: 0,
    overflowY: 'auto',
    height: '100%'
  },
  deliveryStatusLabel: {
    marginRight: 8
  },
  delStatusContainer: {
    margin: '16px 0px',
    display: 'flex',
    alignItems: 'center'
  },
  divider: {
    backgroundColor: theme.AppBGColor
  },
  dialogRootClass: {
    zIndex: 2002 //more than pro info drawer
  },
});

export default styles;
